import { createCalendarSavedView, readCalendarSavedViews, writeCalendarSavedViews } from "./calendarSavedViews";

const DEMO_SEED_KEY = "zoniq.demoSeeded";

export function isDemoSeeded(): boolean {
  try {
    return localStorage.getItem(DEMO_SEED_KEY) === "1";
  } catch {
    return false;
  }
}

/** Seeds client-side demo preferences (saved views, etc.) — does not create API events. */
export function seedDemoWorkspace(): { savedViewName: string } {
  const views = readCalendarSavedViews();
  const name = "Demo: Upcoming on sale";
  if (!views.some((view) => view.name === name)) {
    const next = createCalendarSavedView(name, {
      searchQuery: "",
      statusFilter: "on_sale",
      cityFilter: "all",
      dateFrom: "",
      dateTo: "",
    });
    writeCalendarSavedViews([...views, next]);
  }
  try {
    localStorage.setItem(DEMO_SEED_KEY, "1");
  } catch {
    /* ignore */
  }
  return { savedViewName: name };
}
